import { type Currency, DEFAULT_CURRENCY } from '@/constants/currency'
import type { BigNumberish } from 'ethers'
import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers'
import { isNumber } from './string'

export const formatNativeAmount = (amount: BigNumberish) => {
    return formatEther(amount)
}

export const formatAmount = (amount: BigNumberish, decimals: bigint | number, fixedDecimals?: number) => {
    const formattedAmount = formatUnits(amount, decimals)
    if (fixedDecimals) {
        return Number(formattedAmount).toFixed(fixedDecimals)
    }
    return formattedAmount
}

export const getNativeAmountInSmallestUnit = (amount: BigNumberish) => {
    return parseEther(amount.toString())
}

export const getAmountInSmallestUnit = (amount: string | number, decimals: bigint | number) => {
    const amountString = amount.toString()
    if (!isNumber(amountString)) {
        return 0n
    }
    return parseUnits(amountString, decimals)
}

export const min = (...values: bigint[]) => {
    return values.reduce((min, current) => (current < min ? current : min), values[0])
}

export const max = (...values: bigint[]) => {
    return values.reduce((max, current) => (current > max ? current : max), values[0])
}

export const getTotalAmountToExchange = (
    amount: bigint,
    exchangeRateInTargetCurrencySmallestUnit: bigint,
    sourceCurrencyDecimals: bigint | number,
    targetCurrencyDecimals: bigint | number,
) => {
    const oneSourceSmallestUnit = BigInt(10) ** BigInt(sourceCurrencyDecimals)
    const oneTargetSmallestUnit = BigInt(10) ** BigInt(targetCurrencyDecimals)
    return (
        (amount * exchangeRateInTargetCurrencySmallestUnit) /
        (oneSourceSmallestUnit + (oneSourceSmallestUnit - oneTargetSmallestUnit))
    )
}

export const formatCurrency = (amount: number, currency: Currency = DEFAULT_CURRENCY) => {
    return `${amount.toFixed(currency.decimals)}`
}
